import { render, staticRenderFns } from "./BracketMatchSettings.vue?vue&type=template&id=4f8e8c10&scoped=true"
import script from "./BracketMatchSettings.vue?vue&type=script&lang=js"
export * from "./BracketMatchSettings.vue?vue&type=script&lang=js"
import style0 from "./BracketMatchSettings.vue?vue&type=style&index=0&id=4f8e8c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e8c10",
  null
  
)

export default component.exports